<p>delete-modal works!</p>

<button [routerLink]="['/auth']" routerLinkActive="router-link-active"  class="btn btn-danger text-center">Hello</button> 
